import React from 'react'
// HEADER
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'

const ChatEquipe = () => {
    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <HeaderReturn title='Chat' link='/homePageEquipe' />

        </div>
    )
}

export default ChatEquipe
